import { constants } from "shared/constants";
import { CompanyBasedSectionReports } from "./CompanyBasedSectionReports";

const otherParametersSectionReports = [constants.v360ReportCodes.intermediary.othersSection.other];

class OtherParametersSectionReports extends CompanyBasedSectionReports {
    /**
     *
     */
    constructor() {
        super(otherParametersSectionReports, otherParametersSectionReports);
    }
}

export default new OtherParametersSectionReports();
